import React from 'react';
import { useIntl } from 'react-intl';
import { ErrorPage } from '../components/ErrorPage';
import { ReactComponent as ApplicationErrorIcon } from 'assets/icons/undraw_server_down.svg';
import { Helmet } from 'react-helmet-async';
import { useRecoilValue } from 'recoil';
import { tenantInfoState } from '../atoms';
import { useLocation } from 'react-router-dom';

export const ApplicationErrorPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const tenantInfo = useRecoilValue(tenantInfoState);

  const apiError = location.state.state;

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'ErrorPage.ServerError.Title', defaultMessage: 'Oops... An error has occured' })} - {tenantInfo.name}</title>
        <meta name="description" content={formatMessage({ id: 'ErrorPage.ServerError.Message', defaultMessage: 'Something went wrong.\nPlease try again later, or contact an administrator if the issue persists.' })} />
      </Helmet>
      <ErrorPage
        title={formatMessage({
          id: 'ErrorPage.ServerError.Title',
          defaultMessage: 'Oops... An error has occured',
        })}
        message={formatMessage({
          id: 'ErrorPage.ServerError.Message',
          defaultMessage:
            'Something went wrong.\nPlease try again later, or contact an administrator if the issue persists.',
        })}
        svgImage={<ApplicationErrorIcon style={{ maxWidth: '500px' }} />}
        error={apiError}
      />
    </>
  );
};
